export interface ISocketMessage<T = Record<string, unknown>> {
  id: string
  Notification: {
    Id: string
    NavneregisterId: string
    CorrelationId: string
    Role: string
    Type: string
    SenderSystem: string
    Payload: T
    SentDateTime: Date
    BblCode: string
  }
  NotificationType: SocketMessageTypeEnum
  ReceiverNavneregisterId: string
  ReceivedDateTime: Date
  ReadDateTime: Date
  DeletedDateTime: Date
  ReceivedByUserDateTime: Date
  InitialDelivery: boolean
}

export interface IBellNotificationPayload {
  ItemId: string
  ClientId: string
  Title: string
  Description: string
}

export enum SocketMessageTypeEnum {
  Varsel = 'Varsel',
  OppgaveVarselfristIDag = 'OppgaveVarselfristIDag',
  PaymentCompleted = 'PaymentCompleted',
  PaymentFailed = 'PaymentFailed',
  MeetingCommentsChanged = 'DigitalMeetingCommentChange',
  NoticeCommentChange = 'BulletinBoardCommentChange',

  // DIGITAL KEYS
  UnlocOwnerAccessCreated = 'UnlocOwnerAccessCreated',
  UnlocLockAccessCreated = 'UnlocLockAccessCreated',
  UnlocCreateAccessFailed = 'UnlocCreateAccessFailed',

  // INBOX
  InboxNewEmail = 'InboxNewEmail',
  ReceiptSendingStatus = 'SendingStatus',

  // Meetings module
  BoardMeetingNoticeEmailSent = 'BoardMeetingNoticeEmailSent',
  BoardMeetingNotification = 'BoardMeetingNotification', // Handles updates based on of type sendt in message.

  // Fail test
  FAILED = 'FAILED',

  // Bell notifications
  BellNoticeCommentChanged = 'BellNotificationBulletinBoardCommentChange',
  BellSuggestedSection = 'BellNotificationDigitalMeetingSuggestedSection',
  BellSectionComment = 'BellNotificationDigitalMeetingSectionComment',
  BellBookingCreated = 'BellNotificationBookingCreated',
  BellBookingCancelledByUser = 'BellNotificationBookingCancelledByUser',
  BellInsuranceCaseDraftAccepted = 'BellNotificationInsuranceCaseDraftAccepted',
  BellInsuranceCaseDraftRejected = 'BellNotificationInsuranceCaseDraftRejected',
  BellBoardMeetingNewComment = 'BellNotificationBoardMeetingNewComment',
  BellNewUnitOwnersReadyForApproval = 'BellNotificationNewUnitOwnersReadyForApproval',
  BellLoanImportNewInterestRate = 'BellNotificationLoanImportNewInterestRate',
  BellNewSubleaseApplication = 'BellNotificationNewSubleaseApplication',
  BellSubleaseApproachingEndDate = 'BellNotificationSubleaseApproachingEndDate',
  BellNewPublicationPublishedPortal = 'BellNotificationNewPublicationPublishedPortal',
  BellNewSubleaseRegistered = 'BellNotificationNewSubleaseRegistered',
  BellReimbursementCreated = 'BellNotificationReimbursementCreated',
  BellNotificationMeetingCreated = 'BellNotificationMeetingCreated',
  BellNotificationMeetingAccepted = 'BellNotificationMeetingAccepted',
  BellNotificationMeetingDeclined = 'BellNotificationMeetingDeclined',
  BellNotificationMeetingCancelled = 'BellNotificationMeetingCancelled',
  BellNotificationMeetingChanged = 'BellNotificationMeetingChanged',
  BellNotificationMeetingComment = 'BellNotificationMeetingComment',
  BellNotificationMeetingAttendeeChanged = 'BellNotificationMeetingAttendeeChanged',
  BellNotificationRegistreringAvMaalerstandAapen = 'BellNotificationRegistreringAvMaalerstandAapen',
  BellNotificationDeletePortalDocumentTrash = 'BellNotificationDeletePortalDocumentTrash',

  // Budget
  BellNotificationBudgetPublishedPortal = 'BellNotificationBudgetPublishedPortal',
  BellNotificationBudgetReadyForApproval = 'BellNotificationBudgetReadyForApproval',
  BellNotificationBudgetApprovalDeadlineApproaching = 'BellNotificationBudgetApprovalDeadlineApproaching',
  BellNotificationBudgetNewComment = 'BellNotificationBudgetNewComment',

  // Insurance claims
  InsuranceCaseDraftTransferDone = 'InsuranceCaseDraftTransferDone',
  InsuranceCaseDraftTransferFailed = 'InsuranceCaseDraftTransferFailed',
}

export enum BoardMeetingNotificationTypeEnum {
  MeetingUpdated,
  MeetingCaseUpdated,
  MeetingReadyForSigning,
  MeetingSigningCancelled,
  MeetingSigningCompleted,
  MeetingLastPersonSigned,
}

export enum SocketPaymentTypeEnum {
  MembershipRenewal = 'MembershipRenewal',
  Sublease = 'Sublease',
}

export const mapApiSocketModel = (notificationModel): ISocketMessage => {
  return {
    id: notificationModel.id,
    NotificationType:
      notificationModel.notificationType as SocketMessageTypeEnum,
    Notification: {
      Id: notificationModel.notification.id,
      CorrelationId: notificationModel.correlationId,
      NavneregisterId: notificationModel.notification.navneregisterId,
      Role: notificationModel.notification.role,
      Type: notificationModel.notification.type,
      SenderSystem: notificationModel.notification.senderSystem,
      Payload: notificationModel.notification.payload,
      SentDateTime: notificationModel.notification.sentDateTime,
      BblCode: notificationModel.notification.bblCode,
    },
    ReceiverNavneregisterId: notificationModel.receiverNavneregisterId,
    ReceivedDateTime: notificationModel.receivedDateTime,
    ReadDateTime: notificationModel.readDateTime,
    DeletedDateTime: notificationModel.deletedDateTime,
    ReceivedByUserDateTime: notificationModel.receivedByUserDateTime,
    InitialDelivery: notificationModel.initialDelivery,
  }
}
